(() => {
  const COLOR_CLASSES = ['color-background-1', 'color-background-2', 'color-background-3', 'color-background-4', 'color-background-5'];

  const initializeProductSlider = (section) => {
    if (!section || section.dataset.oixProductSliderReady === 'true') return;
    const root = section.querySelector('[data-oix-product-slider]');
    const productContainer = root?.querySelector('.swiper-product-slider');
    const imageContainer = root?.querySelector('.product-slider__right-block');
    if (!root || !productContainer || !imageContainer || typeof window.Swiper !== 'function') return;

    section.dataset.oixProductSliderReady = 'true';

    const nextButton = root.querySelector('.swiper-button-next__prod-slider');
    const prevButton = root.querySelector('.swiper-button-prev__prod-slider');
    const pagination = root.querySelector('.product-slider__swiper-pagination');
    const floatingLink = root.querySelector('[data-oix-floating-link] a');

    const sharedParams = {
      centeredSlides: false,
      slidesPerView: 1,
      autoHeight: false,
      updateOnWindowResize: true,
      preloadImages: false,
      spaceBetween: 4,
      allowTouchMove: true,
      watchOverflow: true
    };

    const imageSwiper = new window.Swiper(imageContainer, {
      ...sharedParams,
      allowTouchMove: true
    });

    const productSwiper = new window.Swiper(productContainer, {
      ...sharedParams,
      navigation: { nextEl: nextButton, prevEl: prevButton },
      pagination: { el: pagination, clickable: true }
    });

    if (productSwiper.controller && imageSwiper.controller) {
      productSwiper.controller.control = imageSwiper;
      imageSwiper.controller.control = productSwiper;
    }

    const updateActiveState = () => {
      const activeSlide = productSwiper.slides[productSwiper.activeIndex];
      if (!activeSlide) return;

      const scheme = activeSlide.dataset.colorScheme;
      [nextButton, prevButton, pagination].forEach((element) => {
        if (!element) return;
        element.classList.remove(...COLOR_CLASSES);
        if (scheme) element.classList.add(scheme);
      });

      if (floatingLink && activeSlide.dataset.productUrl) {
        floatingLink.href = activeSlide.dataset.productUrl;
        floatingLink.setAttribute('aria-label', `View ${activeSlide.dataset.productTitle || 'product'}`);
      }
    };

    updateActiveState();
    productSwiper.on('slideChange', updateActiveState);
  };

  const initializeWithin = (root = document) => {
    if (root.matches?.('.product-own-slider-section')) initializeProductSlider(root);
    root.querySelectorAll?.('.product-own-slider-section').forEach(initializeProductSlider);
  };

  const initializeDocument = () => initializeWithin(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeDocument, { once: true });
  } else {
    initializeDocument();
  }

  window.addEventListener('load', initializeDocument, { once: true });
  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();
